import axios from 'axios';

const DEFAULT_URL = '/parameters';

export default {
  getAllParameters: () => axios.get(DEFAULT_URL),
  saveParameter: payload => axios.put(DEFAULT_URL + '/parameter', payload),
};
